module.exports = "/static/assets/a246880e69bc7a2a793c90a2fb013ae1.svg";